// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__4RDX4","mainContent":"styles_mainContent__9cbZS"};